module.exports = __webpack_public_path__ + "static/media/icon-status-negotiate.00d54ffc.svg";